// src/modules/app-views/_apps/appcaup/dashboard/config.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import DocumentProvider from 'components/core/DocumentProvider';
import CaupDashboardInit from './pages/Init';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODULE_ID = 'caupDashboard';

// *******************************************************************************
// PRE CONFIG
// *******************************************************************************
const preConfigChanges = appId => {
  CONFIG.appId = appId;
};

// *******************************************************************************
// MODULE CONFIGURATION
// *******************************************************************************
const CONFIG = {
  version: 1,
  id: MODULE_ID,
  initialPage: 'init',
  initialParams: {},
  initialQuery: {},
  api: null,
};

// *******************************************************************************
// MODULE PAGES
// *******************************************************************************
const PAGES = {
  init: {
    layout: 'page',
    moduleId: MODULE_ID,
    component: props => (
      <DocumentProvider {...props} hideBackToHomeLink={false}>
        <CaupDashboardInit />
      </DocumentProvider>
    ),

    api: {
      url: null,
      params: null,
      query: null,
      returnAsObject: false,
      dataDecorator: null,
      autoFetch: false,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: false,
    },

    routing: {
      endpoint: null,
      paramKey: null,
      query: null,
    },

    settings: {
      initialTab: null,
      initialValues: {},
      actions: [],
      showActionsButton: false,
    },

    header: {
      visible: false,
      style: 'default',
      avatar: { visible: false, placeholder: null },
      navigation: { showTitle: false, showBreadcrumb: true },
      buttons: { filter: false, refresh: false, goBack: false, parameters: false },
      stats: { showTotalRecords: false },
      card: { title: null, subtitle: null, column1: null, column2: null, column3: null, tags: null, icons: null, footer: null },
    },

    tabs: {},
    components: {},

    list: {
      table: {
        showLineNumbers: false,
        pagination: { initialPage: 1, pageSize: 100 },
        sorter: { field: 'name', order: 'asc' },
      },
      header: { showFolder: false, showRecordCount: false },
      actions: { columns: [] },
      preview: { title: null, showCard: false, header: null, body: null, actions: null },
      filter: { component: null },
      behavior: { editGoToPage: 'document' },
    },
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default { CONFIG, PAGES, preConfigChanges };
